/**
 * Urban Module
 *
 * @version 1.0
 * @module core/modules/urban
 *
 * @description
 * Módulo de Planificación Urbana: parcelas, edificios, zonificación, usos de suelo.
 * Auto-registro en el moduleRegistry al importarse.
 */

import { moduleRegistry } from '../../module-registry';
import { UrbanTabbedPanel } from './UrbanTabbedPanel';

export { UrbanTabbedPanel };

/* ===== AUTO-REGISTRO DEL MÓDULO ===== */

moduleRegistry.register({
  id: 'urban',
  leftPanel: UrbanTabbedPanel,
  enabledByDefault: false,
});
